import { render, staticRenderFns } from "./JudgingShortcuts.vue?vue&type=template&id=767693bc&"
import script from "./JudgingShortcuts.vue?vue&type=script&lang=js&"
export * from "./JudgingShortcuts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports